import { useFetchInvoicesSummary } from '@features/invoices/hooks/useFetchInvoicesSummary'
import { useFetchQuotesSummary } from '@features/invoices/hooks/useFetchQuotesSummary'

import { DocumentType } from '../../../enums/DocumentType'

interface UseDocumentTabCounterResult {
  counter: number
}

export const useDocumentTabCounter = (documentType: DocumentType, customerId?: string): UseDocumentTabCounterResult => {
  // Without a Zervant externalId the summary endpoint returns the org-wide total instead of
  // erroring, so the badge would advertise every invoice/quote in the org as this client's. Gate
  // the queries on a real customerId.
  const { data: invoicesSummary } = useFetchInvoicesSummary({
    customerId,
    enabled: !!customerId && documentType === DocumentType.INVOICE,
  })
  const { data: quotesSummary } = useFetchQuotesSummary({
    customerId,
    enabled: !!customerId && documentType === DocumentType.QUOTE,
  })

  if (!customerId) {
    return { counter: 0 }
  }

  let counter = 0

  if (documentType === DocumentType.INVOICE && invoicesSummary) {
    counter = invoicesSummary.all.count
  } else if (documentType === DocumentType.QUOTE && quotesSummary) {
    counter = quotesSummary.all.count
  }

  return { counter }
}
